import { FormFeedback as _FormFeedback, FormFeedbackProps as _FormFeedbackProps } from "reactstrap";

    export const FormFeedback = _FormFeedback;
    export type FormFeedbackProps = _FormFeedbackProps;
    